import { usermode } from '../types/smart_search_user_modes';
import { CookieReaderHelper } from './cookie_reader_helper';

export class SearchRequestResponseHeaders {
  private _postRequestHeaders = {};
  private _getRequestHeaders = {};

  constructor(userMode: usermode) {
    this._getRequestHeaders = {
      'user-mode': userMode
    };
    this._postRequestHeaders = {
      'user-mode': userMode,
      ...this.csrfHeader
    };
  }

  get postRequestHeaders() {
    return this._postRequestHeaders;
  }

  get getRequestHeaders() {
    return this._getRequestHeaders;
  }

  private get csrfHeader() {
    const csrfToken = new CookieReaderHelper().getCookie('csrftoken');
    return {
      'X-CSRFToken': csrfToken
    };
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/smart_catalog/helpers/smart_search_request_response_headers_helper.ts